import { useEffect, useState } from "react";
import { Button, NewPhaseForm, ProjectPhase, ToggleButton } from "../../components";

const ProjectPhasesForm = ({ id, onNextStep, isCurrentStep }) => {
  const [showForm, setShowForm] = useState(isCurrentStep);
  const [showNewInput, setShowNewInput] = useState(false);
  const [phases, setPhases] = useState([]);

  useEffect(() => {
    setShowForm(isCurrentStep);
  }, [isCurrentStep]);

  const [projectData, setProjectData] = useState({});
  useEffect(() => {
    if (!isCurrentStep) return;
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) setPhases(savedData);
    const savedProjectData = JSON.parse(localStorage.getItem("project_details_form"));
    if (savedProjectData) {
      const phaseNumber = savedData ? savedData.length + 1 : 1;
      setProjectData({
        emi: +savedProjectData.emi_options?.value ?? "",
        token_percent: savedProjectData?.token_percent ?? "",
        development_charges: savedProjectData?.development_charges ?? "",
        registration_charges: savedProjectData?.registration_charges ?? "",
        start_range: savedProjectData?.start_range ?? "",
        end_range: savedProjectData?.end_range ?? "",
        phase_name: `Phase ${phaseNumber}`,
        plot_area_max: savedProjectData?.plot_area_max ?? "",
      });
    }
  }, [id, isCurrentStep]);

  // const [projectData, setProjectData] = useState({});

  // useEffect(() => {
  //   if (isNewProject) {
  //     const storedProjectData = JSON.parse(localStorage.getItem("project_details_form"));
  //     const projectData = {
  //       emi: storedProjectData.emi_options,
  //     };
  //   }
  // });

  const handleAddNewPhase = (data) => {
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) localStorage.setItem(id, JSON.stringify([...savedData, data]));
    localStorage.setItem(id, JSON.stringify([data]));
    setPhases((prev) => [...prev, data]);
    setShowNewInput(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const savedData = JSON.parse(localStorage.getItem(id));
    const data = savedData.map((phase, index) => ({
      ...phase,
      phase_number: index + 1,
    }));
    onNextStep({ phases: data });
  };

  return (
    <>
      <section className="section_wrapper">
        <section className="section_title_wrapper">
          <h3 className="section_title">Phase List</h3>
          {isCurrentStep && (
            <Button className="ghost_no_underline" onClick={() => setShowNewInput(true)} disabled={showNewInput} small>
              + <span className="underline">Add Phase</span>
            </Button>
          )}
          <ToggleButton open={showForm} onClick={() => setShowForm((prev) => !prev)} />
        </section>
        <section className={`section_wrapper ${showForm ? "" : "hide"}`}>
          {(showNewInput || phases.length === 0) && (
            <NewPhaseForm
              handleSubmit={handleAddNewPhase}
              handleCancel={() => setShowNewInput(false)}
              showCancel={phases.length > 0}
              disableInputs={!isCurrentStep}
              formId={id}
              projectData={projectData}
            />
          )}
          {phases.length > 0 && phases.map((phase, index) => <ProjectPhase key={index} data={phase} isNew={true} />)}
          <Button
            className="submit"
            form="project_phases_form"
            end
            disabled={!isCurrentStep || phases.length === 0}
            onClick={handleSubmit}
          >
            SAVE
          </Button>
        </section>
      </section>
    </>
  );
};
export default ProjectPhasesForm;
